import { KEYS, createTSlatePlugin, getInjectMatch } from "platejs";

//#region src/lib/transforms/setIndent.ts
/** Add offset to the indentation of the selected blocks. */
const setIndent = (editor, { getNodesOptions, offset = 1, setNodesProps, unsetNodesProps = [] }) => {
	const { nodeKey } = editor.getInjectProps(BaseIndentPlugin);
	const _nodes = editor.api.nodes({
		block: true,
		mode: "lowest",
		...getNodesOptions
	});
	const nodes = Array.from(_nodes);
	editor.tf.withoutNormalizing(() => {
		nodes.forEach(([node, path]) => {
			const newIndent = (node[nodeKey] ?? 0) + offset;
			const props = setNodesProps?.({ indent: newIndent }) ?? {};
			if (newIndent <= 0) editor.tf.unsetNodes([nodeKey, ...unsetNodesProps], { at: path });
			else editor.tf.setNodes({
				[nodeKey]: newIndent,
				...props
			}, { at: path });
		});
	});
};

//#endregion
//#region src/lib/transforms/indent.ts
/** Increase the indentation of the selected blocks. */
const indent = (editor, options) => {
	setIndent(editor, {
		offset: 1,
		...options
	});
};

//#endregion
//#region src/lib/transforms/outdent.ts
/** Decrease the indentation of the selected blocks. */
const outdent = (editor, options) => {
	setIndent(editor, {
		offset: -1,
		...options
	});
};

//#endregion
//#region src/lib/withIndent.ts
/**
* - `node.indent` can not exceed `indentMax`
* - `node.indent` is unset if `node.type` is not in `types`
*/
const withIndent = ({ editor, getOptions, plugin, tf: { normalizeNode, tab } }) => ({ transforms: {
	normalizeNode([node, path]) {
		const { indentMax } = getOptions();
		const element = node;
		const { type } = element;
		const match = getInjectMatch(editor, plugin);
		if (type) {
			if (match(element, path)) {
				if (indentMax && element.indent && element.indent > indentMax) {
					editor.tf.setNodes({ indent: indentMax }, { at: path });
					return;
				}
			} else if (element.indent) {
				editor.tf.unsetNodes("indent", { at: path });
				return;
			}
		}
		return normalizeNode([node, path]);
	},
	tab: (options) => {
		const apply = () => {
			const match = getInjectMatch(editor, plugin);
			const entry = editor.api.block();
			if (!entry) return;
			const [element, path] = entry;
			if (!match(element, path)) return;
			if (options.reverse) outdent(editor);
			else indent(editor);
			return true;
		};
		if (apply()) return true;
		return tab(options);
	}
} });

//#endregion
//#region src/lib/BaseIndentPlugin.ts
const BaseIndentPlugin = createTSlatePlugin({
	key: KEYS.indent,
	inject: {
		isBlock: true,
		nodeProps: {
			nodeKey: "indent",
			styleKey: "marginLeft",
			transformNodeValue: ({ getOptions, nodeValue }) => {
				const { offset, unit } = getOptions();
				return nodeValue * offset + unit;
			}
		},
		targetPlugins: [KEYS.p]
	},
	options: {
		offset: 24,
		unit: "px"
	}
}).overrideEditor(withIndent);

//#endregion
export { setIndent as a, indent as i, withIndent as n, outdent as r, BaseIndentPlugin as t };